import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { SELECT_UNASSIGNED } from '@/components/ui/select-sentinels'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { Formik } from 'formik'
import { object as YupObject, string as YupString } from 'yup'
import classNames from 'classnames'
import { actions } from '../Account/account.slice'
import { deleteUser, fetchAccountUsers } from '../Account/account.asyncActions'
import {
	selectAccountUsers,
	selectSelectedRow,
} from '../Account/account.selector'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { selectUser } from '../Profile/profile.selectors'
import { useAuth0 } from '@auth0/auth0-react'

const { setAccountModal, setSelectedRow } = actions

const DeleteModal = () => {
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setAccountModal(null))
		dispatch(setSelectedRow({}))
	}
	const accountUsers = useSelector(selectAccountUsers)
	const selectedUser = useSelector(selectSelectedRow)
	const user = useSelector(selectUser)
	const { logout } = useAuth0()

	const moveAssignmentTo = accountUsers
		.filter((each) => each.id !== selectedUser.id && each.userRole !== 0)
		.map((each) => {
			return {
				value: each.id,
				label: each.name,
			}
		})

	useEffect(() => {
		dispatch(showModal())
	})
	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const validationSchema = YupObject().shape({
		userName: YupString()
			.required('User Name is Required')
			.matches(selectedUser.name, 'User name does not match'),
	})
	const initialValues = {
		userName: '',
		moveAssignment: '',
	}
	return (
		<Formik
			enableReinitialize={true}
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				dispatch(
					deleteUser({
						userId: selectedUser.id,
						data: { newId: values.moveAssignment },
					})
				).then(({ payload }) => {
					if (payload) {
						payload === user.id
							? logout({ returnTo: window.location.origin })
							: dispatch(fetchAccountUsers({ useCaching: false }))
					}
					dispatch(setAccountModal(null))
					dispatch(setSelectedRow({}))
					resetForm()
					setSubmitting(false)
				})
			}}
		>
			{({
				values,
				errors,
				touched,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				setFieldValue,
			}) => {
				const footer = (
					<div className='align-item-right'>
						<Button
							className='h-50 w-190 mr--10'
							variant='outline'
							onClick={handleClose}
						>
							Cancel
						</Button>
						<Button
							className='h-50 w-190'
							onClick={handleSubmit}
							disabled={isSubmitting}
						>
							<BusyIndicator region={REGIONS.DELETE_ACCOUNT_USER}>
								Delete User
							</BusyIndicator>
						</Button>
					</div>
				)
				return (
					<>
						<Modal
							footer={footer}
							reset={resetModal}
							size='md'
							title='Are Your Sure You Want to Delete This User?'
						>
								<div className='f-14'>
									<div className='form-group'>
									<h6 className='mb-25'>
										Please confirm deletion by typing the users name.
									</h6>
										<Label className='font-weight-normal'>{`Type "${selectedUser.name}"`}</Label>
										<Input
											type='text'
											name='userName'
											value={values.userName}
											onChange={handleChange}
											onBlur={handleBlur}
											className={classNames({
												error: touched.userName && errors.userName,
											})}
										/>
									{touched.userName && errors.userName && (
										<div className='error-message'>{errors.userName}</div>
									)}
									</div>
									<div className='form-group mt-4'>
										<Label>Move Assignment To:</Label>
										<Select
											value={values.moveAssignment || SELECT_UNASSIGNED}
											onValueChange={(val) => setFieldValue('moveAssignment', val === SELECT_UNASSIGNED ? '' : val)}
										>
											<SelectTrigger className='w-full'>
												<SelectValue placeholder='Select' />
											</SelectTrigger>
											<SelectContent>
												<SelectItem value={SELECT_UNASSIGNED}>unassigned</SelectItem>
												{moveAssignmentTo.map((each) => (
													<SelectItem key={each.value} value={each.value}>
														{each.label}
													</SelectItem>
												))}
											</SelectContent>
										</Select>
									</div>
								</div>
						</Modal>
					</>
				)
			}}
		</Formik>
	)
}
export default DeleteModal
